
import Menu from "./Menu";

function Header() {  

    return (
      <div className="header">
      <h1 className='header__title'>ruadaslucia</h1>
      <Menu/>
      </div>

      
      
    );
  }
  
  export default Header;